export default __webpack_public_path__ + "static/media/nongyin.57e6d9e7.png";